import demo from './modules/demo'
import personal from './modules/personal'
import sys from './modules/sys'
import patientManager from './modules/patientManager'
import patientEducation from './modules/patientEducation'
import deviceManage from './modules/deviceManage'
import user from './modules/user'
import homePage from './modules/homePage'
import message from './modules/message'

import layoutHeaderAside from '@/layout/header-aside'

import { LoginCallback } from '@okta/okta-vue'

const meta = { requiresAuthA: true }
const normal = [
  // 首页 必须 name:index
  {
    path: 'index',
    name: 'index',
    meta,
    component: () => import('@/pages/index')
  },
  // 刷新页面 必须保留
  {
    path: 'refresh',
    name: 'refresh',
    hidden: true,
    component: {
      beforeRouteEnter (to, from, next) {
        next(vm => vm.$router.replace(from.fullPath))
      },
      render: h => h()
    }
  },
  // 页面重定向 必须保留
  {
    path: 'redirect/:route*',
    name: 'redirect',
    hidden: true,
    component: {
      beforeRouteEnter (to, from, next) {
        next(vm => vm.$router.replace(JSON.parse(from.params.route)))
      },
      render: h => h()
    }
  }
]

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    // redirect: { name: 'index' },
    component: layoutHeaderAside,
    children: normal,
    redirect: to => {
      if (window.location.href.indexOf('?code=') > 0) {
        let code = window.location.href.substring(window.location.href.indexOf('code='), window.location.href.lastIndexOf('#'))
        let query = {}
        code.split('&').forEach((item) => {
          let params = item.split('=')
          query[params[0]] = params[1]
        })
        // console.log('首页判断，来自okta的登录', query)
        if (query.code && query.state) {
          return { path: '/okta/login/callback', query: query }
        }
      }
      return { name: 'index' }
    }
  },
  demo,
  patientManager,
  patientEducation,
  deviceManage,
  sys,
  personal,
  user,
  homePage,
  message
]

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login')
  },
  {
    path: '/okta/login',
    name: 'oktaLogin',
    component: () => import('@/pages/oktaLogin/index'),
    children: [
      { path: '', name: 'oktaLoginIndex', component: () => import('@/pages/oktaLogin/login') },
      { path: 'callback', name: 'oktaLoginCallback', component: LoginCallback },
      { path: 'success', name: 'oktaLoginSuccess', component: () => import('@/pages/oktaLogin/success') },
      { path: 'logout', name: 'oktaLoginLogout', component: () => import('@/pages/oktaLogin/logout') }
    ]
  },
  // 手机富文本预览页面地址
  {
    path: '/patientEducation/phonePreview',
    name: `preview`,
    component: () => import('@/pages/patientEducation/phonePreview')
  },
  {
    path: '/',
    name: 'screenChartsInside',
    redirect: { name: 'index' },
    component: () => import('@/pages/screenChartsInside'),
    children: (pre => [
      { path: 'screenChartsInside', name: `${pre}index`, component: () => import('@/pages/screenChartsInside'), meta: { title: '呼吸机数据分析热力图' } }
    ])('screenChartsInside-')
  },
  {
    path: '/',
    name: 'screenChartsInsideDealer',
    redirect: { name: 'index' },
    component: () => import('@/pages/screenChartsInsideDealer'),
    children: (pre => [
      { path: 'screenChartsInsideDealer', name: `${pre}index`, component: () => import('@/pages/screenChartsInsideDealer'), meta: { title: '呼吸机代理商数据分析热力图' } }
    ])('screenChartsInsideDealer-')
  },
  {
    path: '/',
    name: 'screenChartsInsideDoctor',
    redirect: { name: 'index' },
    component: () => import('@/pages/screenChartsInsideDealer/indexForDoctor'),
    children: (pre => [
      { path: 'screenChartsInsideDealer/indexForDoctor', name: `${pre}index`, component: () => import('@/pages/screenChartsInsideDealer/indexForDoctor'), meta: { title: '呼吸机医生数据分析热力图' } }
    ])('screenChartsInsideDealer-')
  },
  {
    path: '/screenCharts',
    name: 'screenCharts',
    component: () => import('@/pages/screenCharts/first'),
    children: [
      { path: 'index', name: 'ScreenChartsIndex', component: () => import('@/pages/screenCharts'), meta: { screenChartAuth: true } },
      { path: ':privateKey', name: 'ScreenChartsLogin', component: () => import('@/pages/screenCharts/login'), meta: {} },
      { path: '', name: 'ScreenChartsLogin', component: () => import('@/pages/screenCharts/login'), meta: {} }
    ]
  },
  { path: '/patientManager/detailPage/useTimeDetailPage', name: `patient-useTimeDetailPage`, component: () => import('@/pages/patientManager/detailPage/useTimeDetail'), meta: { meta, title: '患者每日报告详情' } }
]

/**
 * 错误页面
 */
const errorPage = [
  // 404
  {
    path: '*',
    name: '404',
    component: () => import('@/pages/error-page-404')
  }
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut,
  ...errorPage
]
